import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { PrivilegeService } from '../services/privilege.service';
import { AuthOktaService } from '../services/auth/auth-okta.service';

@Injectable({
  providedIn: 'root'
})
export class LoginRedirectGuard implements CanActivate {
  constructor(private authOktaService: AuthOktaService, private privilegeService: PrivilegeService) {
  }

  async canActivate(): Promise<boolean> {
    // Wait for organization ID to be fetched before deciding
    await this.authOktaService.getOrganizationId();

    // Now check if MFA is enabled based on the fetched organization ID
    if (this.privilegeService.isAuth0Enabled()) {
      this.authOktaService.signIn();
      return false;
    }
    return true;
  }
}
